import React from 'react';
import { CountryCodePicker } from './CountryCodePicker';
import { formatPhoneDisplay } from '../utils/phoneFormat';

interface PhoneNumberInputProps {
  countryCode: string;
  phone: string;
  onCountryCodeChange: (code: string) => void;
  onPhoneChange: (digits: string) => void;
  error?: string;
  id?: string;
  onPhoneComplete?: (digits: string) => void;
  inputClassName?: string;
}

export function PhoneNumberInput({
  countryCode,
  phone,
  onCountryCodeChange,
  onPhoneChange,
  error,
  id = 'phone',
  onPhoneComplete,
  inputClassName = '',
}: PhoneNumberInputProps) {
  return (
    <div>
      <div className="flex gap-2">
        <div className="w-[100px] shrink-0">
          <CountryCodePicker value={countryCode} onChange={onCountryCodeChange} />
        </div>
        <input
          type="tel"
          inputMode="numeric"
          id={id}
          value={formatPhoneDisplay(phone)}
          onChange={(e) => {
            const digits = e.target.value.replace(/[^\d]/g, '').slice(0, 10);
            onPhoneChange(digits);
            if (digits.length === 10) {
              onPhoneComplete?.(digits);
            }
          }}
          onDoubleClick={(e) => {
            (e.target as HTMLInputElement).select();
          }}
          maxLength={12}
          className={`
            w-full px-4 py-3 rounded-xl border-2 transition-colors
            ${error ? 'border-site-danger/40 focus:border-site-danger' : `border-site-border ${inputClassName}`}
            focus:outline-none
          `}
          placeholder="555-123-4567"
        />
      </div>
      {error && <p className="text-site-danger text-sm mt-1">{error}</p>}
    </div>
  );
}
